'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Pads a number with a leading zero if it is lower than 10
 * @private
 * @param {number} n
 * @return {String}

 */
var leadingZero = function leadingZero(n) {
  return n < 10 ? '0' + n : n;
};

/**
 * Renders a coundown in a simple div.
 * A data-attribute `data-warning` is added when the timerWarning is
 * active.
 *
 * @public
 * @param {Object} data
 *   Time data
 * @param {number} data.days
 *   Remaining days
 * @param {number} data.hours
 *   Remaining hours
 * @param {number} data.minutes
 *   Remaining minutes
 * @param {number} data.seconds
 *   Remaining seconds
 * @param {Boolean} isDone
 *   Triggered when the timer is done
 * @param {Boolean} timerWarning
 *   Triggered when the warning limit has been reached
 * @return {ReactElement}
 */
/* eslint-disable react/prop-types */
var renderSimpleCountdown = function renderSimpleCountdown(_ref, isDone, timerWarning) {
  var days = _ref.days,
      hours = _ref.hours,
      minutes = _ref.minutes,
      seconds = _ref.seconds;

  var props = {};
  if (!days && !hours && minutes * 60 + seconds < timerWarning) {
    props['data-warning'] = '';
  }
  return _react2.default.createElement(
    'span',
    props,
    leadingZero(hours),
    ':',
    leadingZero(minutes),
    ':',
    leadingZero(seconds)
  );
};

exports.default = renderSimpleCountdown;